import { BodyLayout, Page } from '@roc/feature-app-core';
import { NotFound } from '@roc/ui';
import { useRoutes } from '@roc/client-portal-shared/hooks';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useLenderPortalStore } from '../hooks';
import { observer } from 'mobx-react';
import { LoanTypeOptions, useThirdPartyLoanRoutes } from '@roc/feature-third-party-loans';

export const ExternalCapitalView = observer(() => {
  const { globalStore } = useLenderPortalStore();
  const { thirdPartyLoanRoutes, thirdPartyPreferencesRoutes } = useRoutes();
  const { thirdPartyLoanRoutesConfig } = useThirdPartyLoanRoutes();

  const routes = [
    thirdPartyLoanRoutes.fixFlip,
    thirdPartyLoanRoutes.groundUp,
    thirdPartyLoanRoutes.singleProperty,
    thirdPartyLoanRoutes.rentalPortfolio,
    thirdPartyLoanRoutes.stabilizedBridge,
    thirdPartyLoanRoutes.otherBridge,
    thirdPartyLoanRoutes.otherRental,
    thirdPartyLoanRoutes.editFixFlip,
    thirdPartyLoanRoutes.editGroundUp,
    thirdPartyLoanRoutes.editSingleProperty,
    thirdPartyLoanRoutes.editStabilizedBridge,
    thirdPartyLoanRoutes.editOtherBridge,
    thirdPartyLoanRoutes.editOtherRental,
    thirdPartyLoanRoutes.editRentalPortfolio,
    thirdPartyPreferencesRoutes.preferences,
  ];

  return (
    <BodyLayout>
      <Switch>
        <Route exact path={thirdPartyLoanRoutesConfig.submitloan.path}>
          <Page routeDefinition={thirdPartyLoanRoutesConfig.submitloan}>
            <LoanTypeOptions />
          </Page>
        </Route>
        {React.Children.toArray(routes.map(x => x))}
        <Route
          exact
          path={'/'}
          render={() => {
            return <Redirect to={thirdPartyLoanRoutesConfig.submitloan.url} />;
          }}
        />
        <Route
          exact
          path={globalStore.routeBasePath}
          render={() => {
            return <Redirect to={thirdPartyLoanRoutesConfig.submitloan.url} />;
          }}
        />
        <Route>
          <NotFound />
        </Route>
      </Switch>
    </BodyLayout>
  );
});
